module.exports = __webpack_public_path__ + "img/login.df248e37.png";